<template>
    <v-list-item 
        class="v-list-item v-list-sub-item"
        :active-class="color"
        :to="to"
    >
      <v-badge
          left
          class="badge-fix"
          color="red"
          :value="badge > 0"
      >
          <template v-slot:badge>
              <span>{{ badge }}</span>
          </template>
        <v-list-item-title>
            <v-icon v-if="icon" size="18" style="width: 24px;text-align: center;"> {{ icon }} </v-icon>
            {{ text }}
        </v-list-item-title>
      </v-badge>
    </v-list-item>
</template>

<script>
import {
    mapState,
} from 'vuex';

export default {
    props: ["text", "to", "badge", "icon"],
    computed: {
        ...mapState('app', ['image', 'color']),
    }
}
</script>

<style lang="scss">
.v-list-sub-item {
    margin-left: 40px !important;
}

.v-list-sub-item.v-list-item {
    display: block;
    min-height: 32px;
    height: 32px;
    line-height: 32px;
    vertical-align: middle;
}

.v-list-sub-item .v-list-item__title {
    display: inline;
}

.v-list-sub-item .v-icon {
    padding-bottom: 3px;
}
</style>

<style lang="scss">
.badge-fix .v-badge__badge.red {
    top: -5px;
}
</style>

